import { Component } from "@angular/core";
import { RouterModule } from "@angular/router";
import { AuthHeroComponent } from "src/app/modules/authentication/_components/auth-hero/auth-hero.component";
import { SiteHeaderComponent } from "../../components/site-header/site-header.component";

@Component({
    selector: "app-auth-layout",
    standalone: true,
    imports: [RouterModule, AuthHeroComponent, SiteHeaderComponent],
    templateUrl: "./auth-layout.component.html",
    styleUrls: ["./auth-layout.component.scss"],
})
export class AuthLayoutComponent {}
